<template>
    <div class="col-sm-6 col-lg-3">
        <div class="card card-height card-hover-rise mb-0" :style="{ 'background-color': bgColor }">
            <div class="d-flex justify-content-between">
                <div class="text-left card-head">
                    <h5 class="px-1 pt-1 font-bold">{{ title }}</h5>
                </div>
            </div>
            <hr class="m-0">
            <div @click="handleClick" class="cursor-pointer card-body d-flex justify-content-between align-items-center p-1">
                <div class="truncate">
                    <h4 class="mb-25 font-bold text-left">{{ getFormattedCount(count) }}</h4>
                </div>
                <span class="b-avatar badge-light-primary rounded-circle">
                    <span class="b-avatar-custom">
                        <img v-if="icon" class="icon-img" :src="icon" alt="No Image">
                    </span>
                </span>
            </div>
        </div>
    </div>
</template>

<script setup>

import figureFormatter from "@/services/utils/figureFormatter";
import { useRoute, useRouter } from "vue-router";
import useDate from "@/services/utils/day";
import { useStore } from "vuex";

const { commaFormat } = figureFormatter();

const props = defineProps({
    title: {
        type: String,
        default: 'Total'
    },
    count: {
        type: Number,
        default: 0
    },
    icon: {
        type: String,
        default: ''
    },
    bgColor: {
        type: String,
        default: '#00cfe81f'
    },
    id: {
        type: String,
        default: ''
    }
});

const route = useRoute();
const router = useRouter();

const {currentDate, tomorrowDate} = useDate();

const treatmentCardIds = ['today_treatment_count', 'tomorrow_treatment_count'];

const getFormattedCount = (count) => {
    return count ? commaFormat(count, 0) : 0;
}

const handleClick = () => {
    const params = Object.assign({}, route.params);

    if (treatmentCardIds.includes(props.id)) {
        const date = props.id === 'today_treatment_count' ? currentDate() : tomorrowDate();

        const routePath = router.resolve({
            name: 'dental-schedule-list',
            params: params,
            query: {
                start: date,
                end: date,
                page: 1,
                from: props.id
            }
        });

        window.open(routePath.href, '_blank');
        return;
    }

    if (props.id === 'today_collection') {
        const routePath = router.resolve({
            name: 'money-receipt-statements',
            params: params,
            query: {
                start: currentDate(),
                end: currentDate(),
                page: 1
            }
        });

        window.open(routePath.href, '_blank');
        return;
    }

    if (props.id === 'total_receivables') {
        const routePath = router.resolve({
            name: 'pending-money-receipt',
            params: params,
            query: {
                page: 1
            }
        });

        window.open(routePath.href, '_blank');
        return;
    }
}

</script>

<style scoped>
.card-height {
  min-height: 100px;
}
.icon-img {
  width: 50px;
}
.card-hover-rise {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.card-hover-rise:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}
.font-bold {
  font-weight: bold;
}
.truncate h4{
  font-size: 26px;
}
.card-head {
  h2 {
    font-weight: bold;
  }
}
</style>